import React, { useEffect } from 'react';
import { useFeedStore } from '@/app/store/feedStore';
import { TagChip } from './TagChip';

/**
 * A tag on a feed item, in the colour the admin gave it (SC-376). A tag that is no longer in the
 * active vocabulary - removed by an admin, or retired by SC-376 such as API or Compliance - is
 * shown as a muted legacy chip (decision 1), but only once the vocabulary has loaded, so a slow
 * request never flashes every tag as legacy.
 */
export const ItemTagChip: React.FC<{ tag: string; className?: string }> = ({ tag, className }) => {
  const meta = useFeedStore((state) => state.tagMeta[tag]);
  const loaded = useFeedStore((state) => state.tagsLoaded);
  const ensureTagOptions = useFeedStore((state) => state.ensureTagOptions);

  useEffect(() => {
    if (!loaded) void ensureTagOptions();
  }, [loaded, ensureTagOptions]);

  return (
    <TagChip
      name={tag}
      color={meta?.color}
      legacy={loaded && !meta}
      title={meta?.description}
      className={className}
    />
  );
};
